module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-tel-935bc8323c4b6d5d4eeaee668d5333d2.svg";